import { render } from "./MiniLinkSettings.vue?vue&type=template&id=47d005d2&scoped=true"
import script from "./MiniLinkSettings.vue?vue&type=script&lang=js"
export * from "./MiniLinkSettings.vue?vue&type=script&lang=js"

import "./MiniLinkSettings.vue?vue&type=style&index=0&id=47d005d2&lang=scss&scoped=true"

import exportComponent from "C:\\programs\\dd2.0\\dw-dwms-mini\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d005d2"]])

export default __exports__